<template>
	<AppFilter @apply="onFilter" v-model="filters" :isPadding="true" @retainValues = "retainFilter" ref="appFilter"/>
</template>

<script>
	import AppFilter from "@/components/core/indexNew.vue";
	export default {
		name:"AccountFilter",
		props: {

		},
		beforeMount() {},
		components: {
			AppFilter
		},
		watch: {

		},
		computed: {
			accountsFilter:{
				set(val){
					this.$store.commit('updateAccountsFilter',val)
				},
				get(){
					return this.$store.state.accountsFilter
				}
			}
		},
		async mounted() {
			let vm = this;
			this.$store.dispatch('accounts/getGoCallList', {id:''}).then((res) => {
				vm.list = res.map((e) => {
					e.name = e.first_name 
					if(e.last_name){
						e.name = e.name + " " + e.last_name;
					}
					return e
				})
				vm.list.unshift({id:'all', name:'All'})

				if(Object.keys(vm.$store.state.accounts.advanceFilter).length && vm.accountsFilter.length){
					//update account advance filter name dropdown list for available filters whose list value may update after saving edit accounts.
					vm.accountsFilter.forEach(filter=>{
						if(filter.type=='select' && (filter.name =='go_retail'||filter.name =='go_marketing'||filter.name =='go_ops')){
							filter.values = this.list
						}
						//update selected value for filters by new updated name/email wrt same id from updated dropdown list
						if(filter.value && filter.value.id && vm.$store.state.accounts.advanceFilter[filter.name] && vm.$store.state.accounts.advanceFilter[filter.name]==filter.value.name)
						{
							filter.values.forEach(item=>{
								if(item.id == filter.value.id){
									filter.value = item
									vm.$store.state.accounts.advanceFilter[filter.name]=filter.value.name
								}
							})
						}

					})
					vm.filters = JSON.parse(JSON.stringify(vm.accountsFilter))
					vm.$refs["appFilter"].setFilterActive();
					vm.$emit("getList");
				}
				else{
					vm.setFilters();
				}
			})
		},
		methods: {
			retainFilter(data){

				// console.log(this.filteredValues);
				// for (var obj in this.filteredValues) {
				// 	let index = this.filters.findIndex((res) => {
				// 		obj == res.name
				// 	})
				// 	// this.filters[index].enabled = true;
				// 	// this.filters[index].value = {name: this.filteredValues[obj]}
				// }
				if(Object.keys(this.$store.state.accounts.advanceFilter).length){
					this.filters = JSON.parse(JSON.stringify(this.accountsFilter)) || []
				}
				else{
					this.filters = JSON.parse(JSON.stringify(data)) 
				}

			},
			async onFilter(input) {
				let filters = {};
				for (var i = 0; i < input.length; i++) {
                    {
							filters[input[i].name] = input[i].value;

					}
                }
				filters.advanceSearchType = "account";
				let payload = {};
				if(filters["active_type"]){
					payload.active = filters["active_type"].code
				}
				if(filters["go_retail"]){
					if(filters["go_retail"].name == 'All'){
						payload.go_retail = ''
					}
					else{
						payload.go_retail = filters["go_retail"].name
					}
				}
				if(filters["go_marketing"]){
					if(filters["go_marketing"].name == 'All'){
						payload.go_marketing = '';
					}
					else{
						payload.go_marketing = filters["go_marketing"].name
					}
				}
				if(filters["go_ops"]){
					if(filters["go_ops"].name == 'All'){
						payload.go_ops = '';
					}
					else{
						payload.go_ops = filters["go_ops"].name
				   }
				}
				
				this.$store.state.currentPageNumber = 1;
				this.$store.commit("accounts/setadvanceFilterAccount", payload);
				this.$emit("getList");
			},
			setValues(){
				let data = this.$store.state.accounts.advanceFilter;

				this.filters = this.filters.map((e) => {
					if(data.active){
						if(e.name == 'active_type'){
							if(data.active){
								e.value.push({name:'Active', code:true})
								e.enabled = true
							}
							else{
								e.value.push({name:'Inactive', code:false})
								e.enabled = true
							}
						}

					}
					if(data.go_retail){
						if(e.name == 'go_retail'){
							e.value.push({name:data.go_retail})
							e.enabled = true
						}

					}
					if(data.go_marketing){
						if(e.name == 'go_marketing'){
							e.value.push({name:data.go_marketing})
							e.enabled = true
						}

					}
					if(data.go_ops){
						if(e.name == 'go_ops'){
							e.value.push({name:data.go_ops})
							e.enabled = true
						}

					}
					return e
				})
				
				this.$refs["appFilter"].setFilterActive();
				// this.copyRetainFilter = JSON.parse(JSON.stringify(this.filters))

			},
			setFilters() {
				this.filters = [];
				this.filters = [
					{
						name: "break",
						type: "break"
					},
					{
						name: "active_type",
						label: "Status",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: [
							{
								name: "Active",
								code: true
							},
							{
								name: "Inactive",
								code: false
							 }
						],
						padding:true
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "go_retail",
						label: "Go_Retail",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.list,
						padding:true,
						track:'email'
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "go_marketing",
						label: "Go_marketing",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.list,
						padding:true,
						track:'email'
					},
					{
						name: "break",
						type: "break"
					},
					{
						name: "go_ops",
						label: "Go_ops",
						type: "select",
						placeholder: "Select",
						value: [],
						enabled: false,
						values: this.list,
						padding:true,
						track:'email'
					},
					{
						name: "break",
						type: "break"
					},


				];
				this.accountsFilter = JSON.parse(JSON.stringify(this.filters))
			}

		},
		data() {
			return {
				filters: [],
				list : [],
				// copyRetainFilter:[]
			};
		}
	};
</script>
<style lang="scss">
.multiselect__content-wrapper {
	z-index: 1001;
}
</style>
